import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging';
import { Address } from './address.model';
import { EfaactDataService } from '../efaact.data-service';
import * as data from './MOCK_DATA.json';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

export const entityName = 'Address';
@Injectable({ providedIn: 'root' })
export class AddressDataService extends EfaactDataService<Address> {
    mapItems(item: Address): Address {
        return { id: item.Addressid, ...item };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
    // getAll() {
    //     return of((data as any).default).pipe(
    //         map(items => items.map(p => this.mapItems(p)))
    //     );
    // }
}
